import React from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import './LanguageSwitcher.css';

const LanguageSwitcher: React.FC = () => {
  const { i18n } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();

  const changeLanguage = (language: string) => {
    // Check if we're on a route-based translated page
    if (location.pathname === '/terms' || location.pathname === '/terms-pt') {
      // Navigate to the corresponding language route
      navigate(language === 'en' ? '/terms' : '/terms-pt');
    } else if (location.pathname === '/privacy' || location.pathname === '/privacy-pt') {
      // Navigate to the corresponding language route for privacy policy
      navigate(language === 'en' ? '/privacy' : '/privacy-pt');
    }

    // Always update i18n language for other pages
    i18n.changeLanguage(language);
  };

  return (
    <div className="language-switcher">
      <button 
        className={`lang-btn ${i18n.language === 'en' ? 'active' : ''}`}
        onClick={() => changeLanguage('en')}
        aria-label="Switch to English"
      >
        EN
      </button>
      <button 
        className={`lang-btn ${i18n.language === 'pt' ? 'active' : ''}`}
        onClick={() => changeLanguage('pt')}
        aria-label="Mudar para Português"
      >
        PT
      </button>
    </div>
  );
};

export default LanguageSwitcher;